import {
  ADMIN_SEARCH_TYPES_LOADED,
  ADMIN_SEARCH_TYPES_CLEAR,
  ADMIN_COMPANY_FORM_FIELDS_LOADED,
  ADMIN_COMPANY_FORM_FIELDS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function searchTypesLoaded(searchTypes) {
  return {
    type: ADMIN_SEARCH_TYPES_LOADED,
    payload: { searchTypes },
  };
}

export function searchTypesClear() {
  return { type: ADMIN_SEARCH_TYPES_CLEAR };
}

export function companyFormFieldsLoaded(formFields) {
  return {
    type: ADMIN_COMPANY_FORM_FIELDS_LOADED,
    payload: { formFields },
  };
}

export function companyFormFieldsClear() {
  return { type: ADMIN_COMPANY_FORM_FIELDS_CLEAR };
}

// --- API functions ---
async function fetchSearchTypesApi(token, dispatch) {
  const response = await api.get({
    path: 'admin/search-types',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return json;
}

async function fetchCompanyFormFieldsApi(token, params, dispatch) {
  const response = await api.get({
    path: 'admin/search-types/company-fields',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return json;
}

// --- Public components actions ---
export function clearAdminSearchTypesRequest() {
  return (dispatch) => {
    dispatch(searchTypesClear());
  };
}

export function fetchAdminSearchTypesRequest() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();

      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const response = await fetchSearchTypesApi(adminToken, dispatch);
      dispatch(searchTypesLoaded(response));
      dispatch(setFetchLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(setFetchLoaderReset());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function clearCompanyFormFieldsRequest() {
  return (dispatch) => {
    dispatch(companyFormFieldsClear());
  };
}

export function fetchCompanyFormFieldsRequest(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await fetchCompanyFormFieldsApi(adminToken, params, dispatch);
      dispatch(companyFormFieldsLoaded(response));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
    }
  };
}
